import { withInstall } from "../utils/index.mjs";
import _TextEllipsis from "./TextEllipsis.mjs";
const TextEllipsis = withInstall(_TextEllipsis);
var stdin_default = TextEllipsis;
import { textEllipsisProps } from "./TextEllipsis.mjs";
export {
  TextEllipsis,
  stdin_default as default,
  textEllipsisProps
};
